"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityTypeEnum = void 0;
exports.ActivityTypeEnum = {
    BOUGHT_PACKAGE_COURSE: 'BOUGHT_PACKAGE_COURSE',
    JOINED_TO_BROADCAST: 'JOINED_TO_BROADCAST',
    STARTED_TO_BROADCAST: 'STARTED_TO_BROADCAST',
    TRAINING_WATCHED: 'TRAINING_WATCHED'
};
